module.exports = __webpack_public_path__ + "img/img-6.72446d6a.jpg";